import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../user-list/users.model';

@Component({
  selector: 'app-user-collection',
  templateUrl: './user-collection.component.html',
  styleUrls: ['./user-collection.component.css'],
})
export class UserCollectionComponent {
  @Input() users: ReadonlyArray<User> = [];
  @Output() remove = new EventEmitter<string>();
}
